import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Pastilla translúcida con la misma anatomía que `ChipDeModo`, siempre visible — estas
 * fotos se miran, no se recorren con el mouse buscando botones. `stopPropagation`: la
 * card entera abre el visor.
 *
 * NO se posiciona solo: vive en la barra de acciones de la card (abajo a la derecha,
 * pedido de Mati 2026-09-07), al lado de descargar / enviar a lanzamiento, que la posiciona
 * a ella (ADR-2026-09-07-acciones-rapidas-en-la-card).
 */
export const BotonVerificar: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button
    type="button"
    aria-label="Verificar calidad"
    title="Verificar calidad"
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-black/45 text-white backdrop-blur-sm transition-colors hover:bg-black/60"
  >
    <ShieldCheck className="h-4 w-4" />
  </button>
);
